export default __webpack_public_path__ + "static/media/workout_tracker.e48a00c2.png";